import React from "react";
import { LeftOutlined } from '@ant-design/icons';
import { Button } from 'antd';

const BasePrevious = (props) =>
  <Button className={ "previous-button" } { ...props } ><LeftOutlined className="previous-button-icon" />{ props.text ? props.text : "Previous Page" } </Button>

export default BasePrevious;
